export const carrierTypes = [
  { label: 'Aéreo', value: 'aereo' },
  { label: 'Rodoviário', value: 'rodoviario' },
];
